
import { useTranslation } from "react-i18next";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import helpers from "utils/helpers";

let data = [];

export default function EarningsTrendChart({ graphData }) {
  data = graphData?.map((res) => ({ name: res?._id, earnings: res?.totalAmount }))

  const { t } = useTranslation()
  return (
    <div className="bg-white p-6 rounded-lg shadow mt-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-800">{t("EARNING_TRENDS")}</h2>
      </div>

      <div className="bg-gray-100 p-4 rounded-md">
        {helpers.ternaryCondition(data?.length>0,<ResponsiveContainer width="100%" height={350}>
          <BarChart data={data}  margin={{ top: 30, right: 0, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 12, fill: "#6B7280" }}
              height={60}
              interval={0}
            />
            <YAxis hide />
            <Tooltip
              formatter={(value) => [`${helpers.formattedAmount(value)}`, "Earnings"]}
            />
            <Bar dataKey="earnings" fill="#0a0a0a" radius={[4, 4, 0, 0]} barSize={80}>
              <LabelList
                dataKey="earnings"
                position="top"
                content={<CustomBarLabel />}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>,<div className="flex justify-center items-center h-80">{t("O_NO_RECORD_FOUND")}</div>)}
      </div>
    </div>
  );
}


const CustomBarLabel = ({ x, y, width, value }) => (
  <text
    x={x + width / 2}
    y={y - 5}
    fill="#111827"
    textAnchor="middle"
    fontSize={12}
    fontWeight="500"
  >
    {helpers.formattedAmount(value)}
  </text>
);